import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog45/image1SPXmonthlyrebound.png";
import image14 from "../../../../assets/images/Blog45/image14 hedge fund sellers.png";
import image5 from "../../../../assets/images/Blog45/image5 AI bubble question_.png";
import image6 from "../../../../assets/images/Blog45/image6 relative capex spend has diverged in tech a risk.png";
import image18 from "../../../../assets/images/Blog45/image18 follow the money.png";
import image20 from "../../../../assets/images/Blog45/image20 cathartic rush to money funds.png";
import image9 from "../../../../assets/images/Blog45/image9 jobs data weak.png";
import image10 from "../../../../assets/images/Blog45/image10 thanks be for giving.png";
import image11 from "../../../../assets/images/Blog45/image11 cyber Monday risk for SPX.png";
import image12 from "../../../../assets/images/Blog45/image12 VIX crush.png";
import image13 from "../../../../assets/images/Blog45/image13 1DVIX crush.png";
import image21 from "../../../../assets/images/Blog45/image21 gamma flip back to positive.png";
import image17 from "../../../../assets/images/Blog45/image17 Whaley Breadth Thrust.png";
import image22 from "../../../../assets/images/Blog45/image22 GS N-Prft Tech shorts (1).png";
import image15 from "../../../../assets/images/Blog45/image15 leverage high but off the top.png";
import image16 from "../../../../assets/images/Blog45/image16 cash low at fundies.png";
import image26 from "../../../../assets/images/Blog45/image26 what if the sellers turn buyers_.png";
import image31 from "../../../../assets/images/Blog45/image31 prime book bought after Williams on 21st.png";
import image58 from "../../../../assets/images/Blog45/image58 gold breakout (1).png";
import image62 from "../../../../assets/images/Blog45/image62 silver cup and handle l_t.png";
import image69 from "../../../../assets/images/Blog45/image69 bouncing off BTC ETF average buying price curve.png";
import image65 from "../../../../assets/images/Blog45/image65 silver backwardation.png";
import image72 from "../../../../assets/images/Blog45/image72 BTC MACD cross up.png";
const Blog45 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – December 1st, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Flows Re-Ignite, Volatility Implodes, and Early Signs of a December Melt-Up</p>
        <p>
          What looked like a painful end to November flipped sharply into strength as markets staged one of the most powerful rebound weeks of 2025. Forced selling, negative gamma, and AI panic all
          unwound at once, giving way to a flow-driven surge that caught most traders flat-footed. Despite crypto wobbling and thin holiday liquidity, equities found their footing as structural
          pressure turned supportive.
        </p>
        <p>
          Still, the undertone isn’t entirely calm. Job cuts are accelerating, seasonal patterns point to early-week turbulence, and sentiment remains fragile underneath the relief rally. The market
          appears to be transitioning from “fear of further downside” to “fear of missing December’s upside.”
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Flows Over Fear</p>
              <p>
                Last week’s rally was built almost entirely on positioning.
                <br></br> After spending most of November under pressure, the broad market ripped higher as dealer gamma flipped, hedge funds covered shorts, and month-end flows overwhelmed bearish
                narratives.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="SPX monthly rebound"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="hedge fund sellers"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The AI panic that dominated early November eased as traders reassessed the actual risk behind shifting capex trends. Long-term investment cycles remain intact even as short-term
                uncertainty triggered sharp rotations.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="AI bubble question?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="relative capex spend has diverged in tech a risk"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Flows confirmed the shift. Institutions and retail returned aggressively, while money parked in cash near record highs still represents potential dry powder.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="follow the money"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="cathartic rush to money funds"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">The market wasn’t positioned for good news — so even mediocre news sparked an outsized reversal.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Soft Labour, Global Easing, Seasonal Tension</p>

              <p>
                Recent alternative labour data highlighted a notable softening in conditions — something policymakers can’t ignore. Monthly job cuts, WARN notices, and Challenger layoffs all pushed
                higher, revealing stress beneath headline strength.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="jobs data weak"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                At the same time, global easing remains historically aggressive, with more than 300 rate cuts delivered in the last two years. This liquidity wave is now colliding with weakening
                fundamental data — a setup that often leads to choppy but upward-biased markets.
              </p>
              <p>
                Seasonality complicates near-term flows.<br></br>Thanksgiving week produced four straight green days — a pattern that often leads to Cyber Monday weakness, especially when Treasury
                settlements overlap.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="thanks be for giving"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="cyber Monday risk for SPX"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Volatility remains crushed, with both short-dated and implied measures sitting near lows — a calm that feels increasingly disconnected from economic data.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="VIX crush"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt="1DVIX crush"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Breadth Thrust, Gamma Shift, and Positioning Reset</p>
              <p>
                The most important technical development of the week was the structural shift in dealer positioning. Negative gamma that fueled November’s selling unwound into positive territory,
                stabilising intraday flows.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="gamma flip back to positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>At the same time, a Whaley Breadth Thrust triggered — a rare technical signal that historically precedes strong multi-week and multi-month returns.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="momentum fell off a cliff"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Positioning in unprofitable tech and the most-shorted baskets also showed signs of aggressive unwinds, adding to the upside momentum.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="BTC sentiment"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Leverage remains elevated but no longer at extremes, leaving room for further re-risking if momentum holds.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="leverage high but off the top"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="cash low at fundies"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Forward return frameworks in the models remain constructive, with several upside scenarios opening if institutional supply fades and buyers return.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=" what if the sellers turn buyers?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Sentiment has shifted off the lows, but it remains fragile enough that surprises can still produce sharp swings.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Volatility Crush, Positioning Reset, and Tech Relief</p>
              <p>
                Markets started cautiously but reversed sharply on Friday as gamma flipped positive, Thanksgiving inflows hit, and labour-softening data supported expectations for an imminent policy
                cut. A crypto-driven wobble midweek didn’t derail the broader rebound, and flows turned decisively supportive for the first time in weeks.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Alternative labour data confirmed accelerating job cuts — Challenger layoffs, WARN notices, and monthly job cuts all surged. The softening backdrop strengthened the
                    probability of an early policy cut as underlying labour momentum weakens.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image9}
                      alt=" jobs data weak"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image9)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Flows: </span>
                    <br></br>Hedge funds flipped aggressively, buying at the fastest pace since April, while retail outflows from mid-November marked a capitulation low that institutions quickly
                    absorbed.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image31}
                        alt="prime book bought after Williams on 21st"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image31)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Tech & Positioning:</span>
                    <br></br>Unprofitable tech, one of the most shorted baskets through October–November, saw sharp short-covering as gamma turned positive and flows stabilised. Sentiment toward AI
                    also stabilised after fears of capex displacement eased.
                  </p>
                </li>

                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image22}
                      alt=" GS N-Prft Tech shorts"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image22)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt="commodities still cheap"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br> Gold pushed into breakout territory, while silver displayed classic late-cycle strength with physical tightness and multiple timeframe “cup and handle” structures intact.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image58}
                      alt="gold breakout"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image58)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image62}
                      alt="silver cup and handle"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image62)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br> Bitcoin retraced from its V-shaped flush and bounced off ETF demand zones. MACD and RSI stabilised, suggesting bottoming behaviour at the tail end of a capitulation move.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image69}
                    alt=" bouncing off BTC ETF average buying price curve"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image69)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Metals & Cyclicals:</span>
                    <br></br> Silver’s backwardation and long-term breakout structure continue to highlight tight supply dynamics, reinforcing the view of a multi-asset bottoming phase.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image65}
                    alt="silver backwardation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image65)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Data Cluster Meets Policy Silence</p>
              <p>
                A dense macro calendar collides with policy blackout conditions, leaving markets driven purely by data and flows. With volatility crushed and positioning light, traders face a
                potentially choppy but opportunity-rich week.
              </p>
              <p className="highlightedText">Monday, Dec 1</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global Manufacturing PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>OPEC Meeting</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. ISM Manufacturing, Construction Spending</p>
                </li>
                <li className="themesPointer">
                  <p> European Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p> Treasury Bill Auctions</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Dec 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Terms of Trade (NZ)</p>
                </li>
                <li className="themesPointer">
                  <p>European CPI (Flash)</p>
                </li>
                <li className="themesPointer">
                  <p> U.S. JOLTS Job Openings</p>
                </li>
                <li className="themesPointer">
                  <p>API Oil Stock Data</p>
                </li>
                <li className="themesPointer">
                  <p>10-Year JGB Auction</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Dec 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global Services PMIs</p>
                </li>
                <li className="themesPointer">
                  <p> ADP Employment</p>
                </li>
                <li className="themesPointer">
                  <p>ISM Non-Manufacturing</p>
                </li>
                <li className="themesPointer">
                  <p>Mortgage Applications</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone PPI</p>
                </li>{" "}
              </ul>

              <p className="highlightedText">Thursday, Dec 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>European Construction PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>CAD Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Challenger Job Cuts</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Dec 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p> CAD Employment</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. PCE Inflation</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Consumer Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>Factory Orders</p>
                </li>
                <li className="themesPointer">
                  <p>Tokyo CPI Preview via Global Indicators</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Flows Turned — Now the Test Begins</p>
              <p>
                Liquidity, gamma, and seasonality all shifted bullishly last week, but the setup is still fragile. Labour softens, leverage remains elevated, and any disappointment in this week’s data
                could quickly challenge the rally. For now, flows dominate — but the window is narrow.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Momentum turned constructive as gamma flipped positive. Breadth thrust signals support upside continuation, but any pullback must hold last week’s lows to keep dip-buyers
                    engaged. Program flows favour grind-higher conditions if volatility remains suppressed.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold’s breakout structure strengthens as yields soften. Silver continues to outperform late-cycle, with physical
                    tightness and cup-and-handle formations supporting a higher-beta metals move into year-end.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Capitulation appears complete. ETF demand curves acted as support, and MACD crossovers signal early upside momentum. If
                    global liquidity continues improving, crypto could see renewed flows sooner than expected.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>A policy cut remains increasingly likely as labour data deteriorates. The bigger question is the follow-through — if QT
                    slows and liquidity recirculates, risk assets could stretch higher into December despite macro cracks.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="jobs data weak"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image58}
                    alt="gold breakout"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image58)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image72}
                    alt="BTC MACD cross up"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image72)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">Flows have clearly improved, but with leverage still elevated, the market will need to validate these gains rather than assume stability.</span>
              </p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1nMDhfEO5eIfGS59nsbBQFQyz3YbLAsxBVEtXY8PVqVU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog45;
